module.exports = __webpack_public_path__ + "img/list.6f68bbd7.png";